import React, {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {routeNames} from "../../Navigation/routeNames";
import {NavigationItem} from "../../../store/navigation/actions/NavigationActionTypes";
import {setNavigationItems} from "../../../store/navigation/actions/NavigationActions";
import {RootStore} from "../../../store/Store";
import {WithServiceState} from "store-fetch-wrappers";
import DirectoryContainer from "./Components/DirectoryContainer";
import XDriveBreadcrumb from "../../Breadcrumbs/XDriveBreadcrumb";
import {
    goToBreadcrumbByAbsolutePath,
    goToHomeBreadCrumb
} from "../../../store/breadcrumb/actions/BreadcrumbActions";
import {useBreadcrumb} from "../../Hooks/useBreadcrumb";
import {getDirectoriesForLocation} from "../../../store/rawDirectoryList/actions/RawDirectoryListActions";
import TopBar from "../Layouts/Layout/Components/TopBar/TopBar";
import TopBarElementTitle from "../Layouts/Layout/Components/TopBar/TopBarElementTitle";
import UploadManager from "../../UploadManager/UploadManager";
import TopBarTabs from "../Layouts/Layout/Components/TopBar/TopBarTabs";

const ServiceWrapper = WithServiceState(DirectoryContainer);

function LeftTopBarElements() {
    return (
        <div className="breadcrumb-bar">
            <TopBarTabs />
        </div>
    );
}

/** Root Component for the XDrive Page */
const XDrive = () => {
    const dispatch = useDispatch();

    const directoryStore = useSelector((state: RootStore) => state.rawDirectoryList);
    const breadcrumb = useBreadcrumb();

    /** Page Setup */
    useEffect(() => {
        const navItems: NavigationItem[] = [
            {
                name: routeNames.xDrive.name,
                path: routeNames.xDrive.path
            }
        ];

        //Set Nav Items
        dispatch(setNavigationItems(navItems));
    }, [dispatch]);

    useEffect(() => {
        dispatch(getDirectoriesForLocation(breadcrumb));
        if (breadcrumb === "") {
            dispatch(goToHomeBreadCrumb());
            return;
        }
        dispatch(goToBreadcrumbByAbsolutePath(breadcrumb));
    }, [breadcrumb, dispatch]);

    return (
        <React.Fragment>
            <TopBar
                titleText="X-Drive"
                leftElem={<TopBarElementTitle title="X-Drive" element={<LeftTopBarElements />} />}
                rightElem={<UploadManager />}
            />
            <div className="page-container mt-4">
                <XDriveBreadcrumb />
                <ServiceWrapper
                    loaderWheelType={"three-ring"}
                    loaderType={"overlay"}
                    showLoadingText={true}
                    placeholderBlockCount={1}
                    {...directoryStore}
                />
            </div>
        </React.Fragment>
    );
};

export default XDrive;
